export const teacher = {
  id: "MENU_TEACHER",
  icon: "GiTeacher",
  text: "Teacher",
  child: [
    {
      id: "MENU_TEACHER.MENU_ITEM_1",
      path: "/teacher/screen-1",
      isPublic: false,
      text: "Submenu 1",
      child: [],
    },
    {
      id: "MENU_TEACHER.MENU_ITEM_2",
      path: "/teacher/screen-2",
      isPublic: false,
      text: "Submenu 2",
      child: [],
    },
  ],
};
